const getReadMoreList = (restOfPosts = [], currentIndex, maxNum = 3) => {
  if (restOfPosts.length < maxNum) return restOfPosts;
  if (currentIndex === 0) return restOfPosts.slice(0, maxNum);
  if (currentIndex > 0 && currentIndex <= restOfPosts.length - (maxNum - 1)) {
    return [
      restOfPosts[currentIndex - 1],
      ...restOfPosts.slice(currentIndex, currentIndex + (maxNum - 1)),
    ];
  }

  if (currentIndex > restOfPosts.length - (maxNum - 1)) {
    return restOfPosts.slice(restOfPosts.length - maxNum);
  }

  return restOfPosts;
};

export default {
  getReadMoreList,
};
